import { TileSubType, WidgetCategory, WidgetCategoryType } from './types';

interface ControlVisibility {
  hidden?: boolean;
}

// Section and control keys mirror the titles/labels rendered in WidgetFilters.tsx.
interface FiltersTabConfig {
  date?: Record<string, ControlVisibility>;
  sortAndTop?: {
    showTop?: ControlVisibility;
    groupOthers?: ControlVisibility;
  };
  conditionsFilters?: Record<string, ControlVisibility>;
}

export interface WidgetTypeConfig {
  filters?: FiltersTabConfig;
}

type WidgetTypeConfigMap = {
  [C in WidgetCategory]?: Partial<Record<WidgetCategoryType<C>, WidgetTypeConfig>>;
};

const widgetTypeConfig: WidgetTypeConfigMap = {
  [WidgetCategory.Tile]: {
    [TileSubType.Trend]: {
      filters: {
        sortAndTop: {
          showTop: { hidden: true },
          groupOthers: { hidden: true },
        },
      },
    },
  },
};

export const getWidgetTypeConfig = <C extends WidgetCategory>(category: C, subType: WidgetCategoryType<C>): WidgetTypeConfig =>
  widgetTypeConfig[category]?.[subType] ?? {};
